'use client';

import { PropsWithChildren, createContext, useContext } from 'react';
import {
  FrontendLoad,
  GetRecommendedSortWeightMapResponse,
  createSortCompareLoadsByRecommendedDesc,
} from '@trucksmarter/shared';

const SortCompareLoadsByRecommendedDescContext = createContext<
  ((a: FrontendLoad, b: FrontendLoad) => number) | null
>(null);

export function useSortCompareLoadsByRecommendedDesc() {
  const compareLoads = useContext(SortCompareLoadsByRecommendedDescContext);

  if (compareLoads === null) {
    throw new Error(
      'useSortCompareLoadsByRecommendedDesc has to be used within <SortCompareLoadsByRecommendedDescProvider>',
    );
  }

  return compareLoads;
}

interface Props {
  weightMap: GetRecommendedSortWeightMapResponse;
}

export default function SortCompareLoadsByRecommendedDescProvider({
  weightMap,
  children,
}: PropsWithChildren<Props>) {
  return (
    <SortCompareLoadsByRecommendedDescContext.Provider
      value={createSortCompareLoadsByRecommendedDesc(weightMap)}
    >
      {children}
    </SortCompareLoadsByRecommendedDescContext.Provider>
  );
}
